import { Provider } from 'react-redux'
import App from 'next/app'
import PropTypes from 'prop-types'
import { useStore } from 'reduxBits/store'

import Root from 'root'
import { isAppRoute } from 'paths'

const MyApp = ({ Component, pageProps, initialReduxState }) => {
  const store = useStore(pageProps?.initialReduxState || initialReduxState)

  return (
    <Provider store={store}>
      <Root>
        <Component {...pageProps} />
      </Root>
    </Provider>
  )
}

MyApp.getInitialProps = async (appContext) => {
  const { ctx } = appContext
  const appProps = await App.getInitialProps(appContext)

  let initialReduxState
  const isAppRoutePath = isAppRoute(ctx.req?.url)
  if (isAppRoutePath) {
    initialReduxState = ctx.req.store.getState()
  }

  return {
    ...appProps,
    ...(isAppRoutePath ? { initialReduxState } : {}),
  }
}

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired,
  initialReduxState: PropTypes.object,
}

export default MyApp
